import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { deleteTenant } from '../../features/deleteTenant/deleteTenantAction';
import { useDispatch } from 'react-redux';
import { Button, Modal, Tooltip, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { getTenantToCourse } from '../../features/tenantToCourse/tenantToCourseAction';

export default function DataGridComponent(props) {

  const { rows, setRows } = props;
  const [showDeleteModal, setShowDeletemodal] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState(null);  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTenant = rows.find((row) => row.id === selectedTenantId);
  const tenantName = selectedTenant ? selectedTenant.tenant : '';
  
  const handleCloseModal = () => {
    setShowDeletemodal(false);
    setSelectedTenantId(null);
  };

  const handleOpenModal = (id) => {
    setSelectedTenantId(id);
    setShowDeletemodal(true);
  };
  
  const handleDelete = () => {
    if (selectedTenantId) {
      dispatch(deleteTenant({tenantId: selectedTenantId})).then((res) => {
        if (res) {
          const updatedRows = rows.filter((row) => row.id !== selectedTenantId);
          setRows(updatedRows);
          toast.success(`Customer ${tenantName} deleted successfully!`);
        }
        setShowDeletemodal(false);
      })
      .catch((error) => {
        console.error("Error deleting customer:", error);
        toast.error("Failed to delete the customer. Please try again.");
      });
    }
    ;
  };

  const handleRedirectCourseDetailScreen = (id) => {
    dispatch(getTenantToCourse({ id }));
    navigate(`/courses/access/${id}`, { state: id })
  }

  const columns = [
    {
      field: 'tenant',
      headerName: 'Customer',
      flex: 1,
      renderCell: (params) => {
        const handleTenantClick = () => {
          const state = {
            tenant: params.row
          };        
          navigate("/customer/detail", { state });
        };
        
        return (
          <Box
            sx={{
              cursor: 'pointer',
              textDecoration: 'none',
              color: '#1976d2',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={handleTenantClick}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.6,
      renderCell: (params) => (
        <Box
          sx={{
            color: params.value  === 'Active' ? '#11b511': 'red',
            fontWeight: 600,
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: 'createdOn',
      headerName: 'Created On',
      flex: 0.6,
    },
    {
      field: 'expiration',
      headerName: 'Expiration',
      flex: 0.6,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.6,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View Courses" arrow>
            <IconButton sx={{color: '#1976d2', marginLeft: "-10px"}} onClick={() => handleRedirectCourseDetailScreen(params.row.id)}>
              <VisibilityOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Customer" arrow>
            <IconButton sx={{color: '#e21616'}} onClick={() => handleOpenModal(params.row.id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ width: '100%', padding: '20px', cursor: 'pointer'}}>
      {rows.length === 0 ? (
      <Box sx={{ textAlign: 'center', padding: '40px' }}>
        <Typography variant="h6" sx={{ color: '#666' }}>
          Customer details not available. Please try again or contact support.
        </Typography>
      </Box>
    ) : (
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnMenu
        disableColumnReorder
        disableSelectionOnClick
        pageSizeOptions={[20]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        sx={{
          width: '100%',
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700",
            color: '#1976d2',
          },
        }}
      />
    )}
      {showDeleteModal && <>
        <Modal open={showDeleteModal} onClose={handleCloseModal}>
          <Box style={{ width: '550px', borderRadius: '16px', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "white", boxShadow: 24, p: 4}}>
            <Typography variant="h6" component="h2" sx={{padding: '20px 0px', fontWeight: '600', color: '#1976d2', textAlign: 'center', borderBottom: '1px solid lightgrey', fontSize: '20px'}}>
                Delete Customer
            </Typography>
            <Box sx={{padding: '32px', display: 'flex', flexDirection: 'column', gap: '20px'}}>
              <Typography variant="h6" component="h2" sx={{ fontSize: '18px' , textAlign: 'center'}}>
                This customer might have the active users, courses <br/> and learners enrolled into them.
                <br/>Are you sure you want to delete this <strong>{tenantName}</strong> Customer?
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", gap: '20px' }}>
                <Button variant="contained" onClick={handleCloseModal} sx={{textTransform: 'capitalize', fontWeight: '600', background: 'transparent', border: '1px solid #1976d2', color: '#1976d2', borderRadius: '10px'}}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleDelete} sx={{textTransform: 'capitalize', fontWeight: '600', borderRadius: '10px'}}>
                  Delete Now
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </>}

    </Box>
  );
}
